import { useState } from "react";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";

/**
 * Tells the customer a default pickup/delivery change didn't save. The star
 * has already flipped back by then, so without this the click looks ignored.
 * Render the returned `dialogs` node.
 */
export function useLocationsDefaultLocationNotice() {
  const [message, setMessage] = useState<string | undefined>();

  const dialogs = (
    <Dialog
      open={message !== undefined}
      onOpenChange={(open) => {
        if (!open) setMessage(undefined);
      }}
      title="Unable to change the default location"
      footer={
        <Button primary onClick={() => setMessage(undefined)}>
          OK
        </Button>
      }
    >
      <ControlPresentationProvider presentation="underlined">
        {message}
      </ControlPresentationProvider>
    </Dialog>
  );

  return { showDefaultLocationNotice: setMessage, dialogs };
}
